<template>
  <div class="app-passivate-sim-card-wrapper">
    <PassivateSimCard
      @showmodal="showModal"
    >
      <template v-for="slot in possibleChildSlotsFor('PassivateSimCard')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </PassivateSimCard>
    <ProcessConfirmModal
      :show.sync="modalShow"
      @next="passivateSimCard()"
      :loading="loading"
      :show-prev="false"
      :slotData="slotData"
      :processClass="'passivate-sim-card-modal'"
      :disabled-next="disabledNext()"
    >
      <template v-for="slot in possibleChildSlotsFor('Modal', slotData.currentStatus)"
                v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </ProcessConfirmModal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import PassivateSimCard from './PassivateSimCard.vue'
import ProcessConfirmModal from '@/components/generic/ProcessConfirmModal.vue'
import slotProxy from '@/mixins/slotProxy'
import transaction from '@/mixins/transaction'
import gql from 'graphql-tag'
import { wrapQuery } from '@/helper/wrapGQLQuery'

export default {
  name: 'PassivateSimCardWrapper',
  components: { ProcessConfirmModal, PassivateSimCard },
  data () {
    return {
      loading: false,
      modalShow: false,
      currentCustomer: {
        contract: {
          simCard: {
            status: '',
            notification: {
              title: '',
              text: '',
              delay: ''
            }
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters('passivateSimCard', [
      'currentStatus'
    ]),
    simCardStatus () {
      return this.currentCustomer.contract.simCard.status
    },
    slotData () {
      if (this.simCardStatus === 'PASSIVATED') {
        return {
          currentStatus: 'Passivated'
        }
      } else {
        return {
          currentStatus: this.currentStatus
        }
      }
    }
  },
  methods: {
    ...mapActions('passivateSimCard', [
      'requestPassivateSimCard'
    ]),
    disabledNext: function () {
      return (this.simCardStatus === 'PASSIVATED') || (this.currentStatus === 'Running')
    },
    async passivateSimCard () {
      this.loading = true
      this.requestPassivateSimCard().then(() => {
        this.loading = false
        this.modalShow = false
      }, () => {
        this.loading = false
        this.modalShow = false
      })
    },
    showModal: function () {
      this.modalShow = true
    }
  },
  apollo: {
    simCardStatus: function () {
      const me = this
      return wrapQuery(gql`query passivateSIMCard {
        currentCustomer {
          contract {
            msisdn,
            simCard {
              status
              notification {
              title
              text
              delay
              }
            }
          }
        }
      }`, this, 'currentCustomer', {},
      function (data) {
        if (data.contract.simCard.status === 'PASSIVATED') {
          me.$store.commit('addMessage', {
            type: 'success',
            message: data.contract.simCard.notification?.text
          }, { root: true })
        }
      }
      )
    }
  },
  mixins: [
    slotProxy(),
    transaction('passivateSimCard')
  ]
}
</script>
